import type { Variants } from "framer-motion"
import React from "react"
import { motion } from "framer-motion"

import { PANEL_EMERGE_VARIANTS } from "~components/shared/motion/motion-variants"
import { pickDataAttributes } from "~components/shared/motion/motion-helpers"

interface Props {
    readonly children: React.ReactNode
    readonly style?: React.CSSProperties
    readonly testId?: string
    readonly variants?: Variants
    readonly transformOrigin?: React.CSSProperties["transformOrigin"]
    readonly [dataAttribute: `data-${string}`]: string | undefined
}

export default function AnimatedPanel({
    children,
    style,
    testId,
    variants = PANEL_EMERGE_VARIANTS,
    transformOrigin = "bottom right",
    ...rest
}: Props) {
    const dataProps = pickDataAttributes(rest)

    return (
        <motion.div
            data-testid={testId}
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            style={{ ...style, transformOrigin }}
            {...dataProps}
        >
            {children}
        </motion.div>
    )
}
